import { ConfigProvider } from 'antd';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import AdminRoute from './components/authentication/AdminRoute';
import Auth from './components/authentication';
import Callback from './components/authentication/Callback';
import ErrorPage from './components/authentication/Error';
import Login from './components/authentication/Login';
import PrivateOutlet from './components/authentication/PrivateRoute';
import SSO from './components/authentication/SSO';
import Dashboard from './components/dashboard';
import AdminUsers from './components/dashboard/admin/UsersList';
import CategoriesList from './components/dashboard/categories';
import AttributeList from './components/dashboard/mapping/attributeList';
import MappingList from './components/dashboard/mapping/list';
import AddAttributesDrawer from './components/dashboard/marketplaces/attributes/AddAttributesDrawer';
import MarketplaceCategories from './components/dashboard/marketplaces/categories';
import AddCategories from './components/dashboard/marketplaces/categories/add';
import Marketplaces from './components/dashboard/marketplaces/list';
import MediasComponent from './components/dashboard/medias';
import MpProductDetails from './components/dashboard/mpProducts/details';
import MpProductsList from './components/dashboard/mpProducts/list';
import MpOffersList from './components/dashboard/mpOffers/list';
import NotificationsPage from './components/dashboard/notifications';
import ProductsAssociation from './components/dashboard/products/association';
import ProductDetails from './components/dashboard/products/details';
import Products from './components/dashboard/products/list';
import ProfileComponent from './components/dashboard/profile/ProfileComponent';
import { useAppTheme as useZustandAppTheme } from './utils/zustand/hooks/useAppTheme';

function App() {
  const zustandTheme = useZustandAppTheme();

  return (
    <ConfigProvider theme={zustandTheme.theme}>
      <Routes>
        <Route path="/" element={<Navigate to="auth" replace />} />

        {/* Routes publiques */}
        <Route path="auth" element={<Auth />}>
          <Route index element={<Navigate to="login" replace />} />
          <Route path="login" element={<Login />} />
          <Route path="sso" element={<SSO />} />
          <Route path="error" element={<ErrorPage />} />
          <Route path="callback/" element={<Callback />} />
          <Route path="silent-callback" element={<div />} />
        </Route>

        {/* Routes protégées */}
        <Route path="dashboard" element={<PrivateOutlet />}>
          <Route element={<Dashboard />}>
            <Route index element={<Navigate to="products" replace />} />
            <Route path="profile" element={<ProfileComponent />} />
            <Route path="categories" element={<CategoriesList />} />
            <Route path="categories/:slug" element={<CategoriesList />} />
            <Route path="categories/:slug/:tab" element={<CategoriesList />} />
            <Route path="medias" element={<MediasComponent />} />
            <Route path="medias/:tab" element={<MediasComponent />} />
            <Route path="products" element={<Products />} />
            <Route path="mp-products" element={<MpProductsList />} />
            <Route path="mp-products/:id" element={<MpProductDetails />} />
            <Route path="mp-offers" element={<MpOffersList />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route
              path="products/mp-association"
              element={<ProductsAssociation />}
            />
            <Route path="products/:reference" element={<ProductDetails />} />
            <Route
              path="products/:reference/:tab"
              element={<ProductDetails />}
            />
            <Route path="mapping" element={<MappingList />} />
            <Route path="mapping/:mappingId" element={<AttributeList />} />
            <Route path="marketplaces" element={<Marketplaces />} />
            <Route
              path="marketplaces/:marketplace/categories/add-categories"
              element={<AddCategories />}
            />
            <Route
              path="marketplaces/:marketplace"
              element={<Marketplaces />}
            />
            <Route
              path="marketplaces/:marketplace/categories"
              element={<MarketplaceCategories />}
            />
            <Route
              path="marketplaces/:marketplace/categories/:category"
              element={<MarketplaceCategories />}
            />
            <Route
              path="marketplaces/:marketplace/categories/:category/:tab"
              element={<MarketplaceCategories />}
            />
            <Route
              path="marketplaces/:marketplace/categories/:category/add-mp-attributes"
              element={<AddAttributesDrawer />}
            />
            <Route
              path="marketplaces/:marketplace/mp-products"
              element={<MpProductsList />}
            />
            {/* Pages admin (reservees aux Promethee:Admin) */}
            <Route path="admin" element={<AdminRoute />}>
              <Route index element={<Navigate to="users" replace />} />
              <Route path="users" element={<AdminUsers />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </ConfigProvider>
  );
}

export default App;
